import React, { Component, useEffect } from "react";
import { Layout, Input, Button, Card, Typography, Form, message, Modal, Result } from "antd";
import "./styles.css";
import loginApi from './api'
import { useNavigator } from "../../utilities/navigation";
import { login } from "../../configurations/login";
import { useMutation, useQuery } from "react-query";
import { useState } from "react";
import {
  useNavigate
} from "react-router";
const Login = (props) => {
  const [navigator] = useNavigator()
  const naviagte = useNavigate()
  const [isModal, setIsModal] = useState(false)
  const [validEmail, setValidEmail] = useState(false)
  const [successMsg, setSuccessMessage] = useState(false)

  const [loginemai, setloginemail] = useState(false)
  const [loginpassword, setloginPassword] = useState(false)
  console.log("login component")
  useEffect(() => {

    const ELEMENT = document.getElementsByClassName("ant-layout-header")
    // console.log(ELEMENT)
    const loggedUser = JSON.parse(localStorage.getItem("loggedUser"))
    if (loggedUser != null && loggedUser.type != 'admin') {
      if (loggedUser?.profileCompleted == true) {
        navigator('/marketplace')
        // navigator("/home")
      }
      else {
        navigator('/profile/edit')
      }
    }
    else if (loggedUser != null && loggedUser.type == 'admin') {
      console.log("Admin route")
      navigator("/marketplace")
      // navigator('/admin/dashboard')
    }

  })
  const mutation = useMutation(async () => {
    let email = document.getElementById("passwordEmail")?.value
    if (email != '') {
      if (/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email) == true) {
        return loginApi.forgetPassword(email)
      } else {
        setValidEmail(true)
        setTimeout(() => {
          setValidEmail(false)
        }, 2000)
      }
    } else {
      setValidEmail(true)
      setTimeout(() => {
        setValidEmail(false)
      }, 2000)
    }
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data != undefined) {
        if (data?.data.success == false) {
          message.error(data?.data?.message, 3)
        }
        else {
          setSuccessMessage(true)
          setTimeout(() => {
          }, 3000)
        }
      } else {

      }
    },
    onError: (error) => {

    }
  })
  const { isLoading, refetch } = useQuery('userlogin', async () => {
    let email = document.getElementById("email")?.value
    let password = document.getElementById("password")?.value
    return loginApi.UserLogin({
      email: email,
      password: password
    })
  }, {
    enabled: false,
    onSuccess: (data) => {
      if (data?.data?.success == false) {
        message.error(data?.data?.message, 3)
      }
      else {
        if (data !== null) {
          if (data?.data != undefined) {
            message.success("You are login now", 2)
            localStorage.setItem("loggedUser", JSON.stringify(data?.data))
            props.getMenu()

            
            if (data?.data?.type == 'admin') {
              navigator('/admin/dashboard')
            } else {
              if (data?.user?.profileCompleted == true) {
                navigator('/userVerification')
              }
              else {
                navigator('/profile/edit')
              }
            }
          }
          else {
            message.error("Something Went Wrong", 2)
          }
        }
      }
    },
    onError: (err) => {
      message.error(err.message, 2)
    }
  })

  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  return (
    <Layout className="layout">
      <Modal title="Recover Password" closable={false} visible={isModal}
        footer={[
          successMsg == false ? <><Button key="back" onClick={() => {
            setIsModal(false)
          }}>
            Cancel
          </Button> <Button
            loading={mutation?.passwordLoading}
            key="back" type="primary" onClick={() => {
              // setIsModal(false)
              // passwordRefetch()
              if (document.getElementById("passwordEmail")?.value != "") {
                mutation.mutateAsync()
              }
              else {
                setValidEmail(true)
                setTimeout(() => {
                  setValidEmail(false)
                }, 2000)

              }
            }}>
              Send
            </Button></> :
            <Button
              loading={mutation?.passwordLoading}
              key="back" type="primary" onClick={() => {
                setSuccessMessage(false)
                setIsModal(false)

              }}>
              Got it
            </Button>]}
      >{successMsg == false ?
        <Form
          className="loginForm"
          layout="vertical"
          name="nest-messages"
          onFinish={() => { }}
          validateMessages={() => { }}
        >
          <Form.Item
            className="form-elemnt"
            name="email"
            label="Enter your Email"
          >
            <Input
              size="large"
              id="passwordEmail"

              autoComplete="off"
              type="email"
              onChange={(e) => {

              }}
            />
            {validEmail && <Text type="danger">Please Enter Valid Email</Text>}
          </Form.Item>
        </Form> : <Result
          status="success"
          title="Recover Password"
          subTitle="Please check your inbox, we just sent you a password recover link."
        ></Result>}
      </Modal>
      <Content style={{ padding: "0 50px" }}>
        <div className="site-layout-content">
          <Card
            style={{ width: 300 }}
            bordered={true}
            className="login-container"
          >
            <Form
              className="loginForm"
              layout="vertical"
              name="nest-messages"
              onFinish={() => { }}
              validateMessages={() => { }}
            >
              <Form.Item>
                <Title level={5} className="form-title">
                  {login["login"].title}
                </Title>
              </Form.Item>

              <Form.Item
                className="form-elemnt"
                name="email"
                label="Email"
              >
                <Input
                  size="large"
                  id="email"

                  autoComplete="off"
                  type="email"
                  onChange={(e) => {

                  }}
                />
                {loginemai == true ? <Text type="danger">Please Enter Valid Email</Text> : null}
              </Form.Item>
              <Form.Item
                className="form-elemnt"
                name="password"
                label="Password"
              >
                <Input
                  size="large"
                  autoComplete="off"
                  id="password"
                  type="password"
                  onChange={(e) => {

                  }}
                />{loginpassword == true ? <Text type="danger">Please Enter Valid Password</Text> : null}
              </Form.Item>
              <Form.Item className="submit-item">
                <Button
                  type="primary"
                  className="submit-btn"
                  htmlType="submit"
                  size="large"
                  loading={isLoading}

                  onClick={() => {
                    let email = document.getElementById("email")?.value
                    let password = document.getElementById("password")?.value
                    // console.log(email);
                    // console.log(password);
                    if (/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(email) == false) {
                      // console.log(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(email))
                      // console.log(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(email))
                      setloginemail(true)
                      setTimeout(() => {
                        setloginemail(false)
                      }, 3000)
                    }

                    else if (email == '' || /^\s*$/.test(email) == true) {
                      setloginemail(true)
                      setTimeout(() => {
                        setloginemail(false)
                      }, 3000)
                    }
                    else if (password == '' && /^\s*$/.test(password) == true) {
                      setloginPassword(true)
                      setTimeout(() => {
                        setloginPassword(false)
                      }, 3000)
                    }
                    else if (email != '' && /^\s*$/.test(email) == false && password != '' && /^\s*$/.test(password) == false) {
                      refetch()
                    }


                  }}
                >
                  Login
                </Button>
              </Form.Item>
              <Form.Item className="NeedHelp">
                <Link
                  onClick={(e) => {
                    e.preventDefault()
                    setIsModal(true)
                  }} target="_blank">
                  Forget Password?
                </Link>
                <Link
                  onClick={(e) => {
                    e.preventDefault()
                    window.location.href = "mailto:user@example.com?subject=Subject&body=message%20goes%20here";
                  }} target="_blank">
                  Need Help?
                </Link>
              </Form.Item>
            </Form>
          </Card>
          <Card
            style={{ width: 300 }}
            className="login-container Register-container"
          >
            <Form
              className="loginForm"
              layout="vertical"
              name="nest-messages"
              onFinish={() => { }}
              validateMessages={() => { }}
            >
              <Form.Item className="Do-have-account">
                <Text>Don't have an account ?</Text>
              </Form.Item>

              <Form.Item className="submit-item">
                <Button
                  type="primary"
                  className="submit-btn form-elemnt reg-btn"
                  htmlType="submit"
                  size="large"
                  onClick={() => {
                    naviagte('/registration')
                  }}
                >
                  Register Here
                </Button>
              </Form.Item>

            </Form>
          </Card>
        </div>
      </Content>
    </Layout>
  );
}


export default Login
